/**
 * Promotion Management Routes
 * Defines routing configuration for promotion management feature
 */

import { Routes } from '@angular/router';
import { OfferListComponent } from './components/offer-list/offer-list.component';
import { OfferUpsertComponent } from './components/offer-upsert/offer-upsert.component';
import { CanDeactivateGuard } from '@app/core/auth/can-deactivate.guard';

export const PROMOTION_MANAGEMENT_ROUTES: Routes = [
  {
    path: '',
    component: OfferListComponent,
    data: {
      breadcrumb: 'Offer Management',
    },
  },
  {
    path: 'create',
    component: OfferUpsertComponent,
    canDeactivate: [CanDeactivateGuard],
    data: {
      breadcrumb: 'Create Offer',
    },
  },
  {
    path: 'edit/:id',
    component: OfferUpsertComponent,
    canDeactivate: [CanDeactivateGuard],
    data: {
      breadcrumb: 'Edit Offer',
    },
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
